// extracted by mini-css-extract-plugin
module.exports = {"logo":"ChicletItem_logo__AUGlL","icon":"ChicletItem_icon__giBY_"};